<mat-form-field *ngIf="formFactoryField$ | async as formFactoryFieldRef">
    <mat-label *ngIf="formFactoryFieldRef.label">{{ formFactoryFieldRef.label }}</mat-label>
    <input matInput [formControl]="formFactoryFieldRef.formControl" />
</mat-form-field>
